import { Environment } from './environment.interface';
import { TEST_API_URLS } from '@k12/api-environment';

export const environment: Environment = {
  adminApiUrl: 'https://testing-api-enrollment.azure-api.net',
  enrollmentToken: '',
  schoolsUrl: 'https://localhost:4600',
  appUrl: 'https://localhost:4500',
  name: 'production',
  production: true,
  providersUrl: '',
  msalClientId: '',
  msalAuthority: 'https://login.microsoftonline.com/4d0b1d13-40fc-479b-870b-9f17bf4b23b6',
  instrumentationKey: '2131bbb8-5175-494b-8c3a-ed6c22229e70',
  app: 'admin',
  apiMode: 'monolith',
  apiUrls: TEST_API_URLS
};
